export default "__VITE_ASSET__Da0ekItT__"